import magnifiAPIInstance from "./apiInstance";

export const organizationMemberAPIs = {
  removeOrganizationMember: ({ payload }) =>
    magnifiAPIInstance.delete(`/organization-member/${payload?.organizationMemberId}`),
  updateOrganizationMember: ({ organizationMemberId, payload }) =>
    magnifiAPIInstance.put(`/organization-member/${organizationMemberId}`, payload),
};
